module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("H1cz1"))).then(() => module.bundle.root('fThBo'));